import BaseApi from '../base/base'
import { UserExamDetail } from '../../models/user_exam'

export default class UserApi extends BaseApi {
  constructor() {
    super()
    this.path = '/user_exams'
  }

  delete(id: number) {
    this.path = `/user_exams/${id}`
    return this.deleteRequest()
  }

  async show(id: number) {
    this.path = `/user_exams/${id}`
    const response = await this.getRequest()
    return new UserExamDetail(response.data)
  }
}
